{#if show}
  <FileUploader 
    bind:show={show}
    url={uploadTo}
    {title}
    {messages}
    {onDone}
    />
{/if}

<script>
  import { onMount, tick } from 'svelte';
  import { Overlay, Panel, Icon, Button, Text, Heading } from 'svelte-stylo';
  import FileUploader from '@/components/dialogs/FileUploader.svelte';

  let
    show = false,
    uploadTo = null,
    onDone = null;

  const title = "Importa un formulario";

  const messages = {
    intro: "Aquí puedes importar un formulario que hayas previamente exportado"
            +" desde esta misma cuenta, o de otra cuenta diferente.",
    select: "Selecciona el archivo a importar ...",
    selected: "Importaremos el archivo", 
    upload: "Subir ahora !",
    working: "Estamos subiendo el archivo", 
    done: "Hemos importado el formulario", 
    continue: "Ya puedes continuar trabajando en este formulario.",
    failed: "Falló la importación del archivo"
  }


  window.RecordDefImportDialog = function () {
    /** 
     * Set this as a global object so we can call it from anywhere
     * for example from the Mediator 
     */
    return {
      open: function(received, callback) {
        uploadTo = "/record-defs/"+received.id+"/import";
        onDone = callback;
        show = true;
      }
    }
  }

</script>